import { render, staticRenderFns } from "./TotalSales.vue?vue&type=template&id=5fda189a&scoped=true"
import script from "./TotalSales.vue?vue&type=script&lang=js"
export * from "./TotalSales.vue?vue&type=script&lang=js"
import style0 from "./TotalSales.vue?vue&type=style&index=0&id=5fda189a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda189a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fda189a')) {
      api.createRecord('5fda189a', component.options)
    } else {
      api.reload('5fda189a', component.options)
    }
    module.hot.accept("./TotalSales.vue?vue&type=template&id=5fda189a&scoped=true", function () {
      api.rerender('5fda189a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/components/TotalSales.vue"
export default component.exports